<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> added a welcome message for-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>.-->
        <span v-html="$t('notification.welcomeMessageAdded', {user:$_.get(activity, 'actorUser.name'),welcome:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WelcomeMessageAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
